import * as Yup from 'yup'
import {useState, useEffect} from 'react'
import {Pricing} from '../../core/_models'
import {updatePricing} from '../../core/_requests'
import {getPricing} from '../../core/_requests'
import {Formik, Form, Field} from 'formik'
import {
  Checkbox,
  InputText,
  CustomSelect,
  FormActions
} from '@/components/form'
import {handleErrors} from '@/components/form/_utils'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'

const PricingForm = () => {
  const {refetch} = useQueryResponse()
  const {setItemForUpdate, setAction} = useListView()
  const [pricing, setPricing] = useState<Array<Pricing>>([])
  const [selected, setSelected] = useState<Pricing|undefined>()
  const [isLoading, setIsLoading] = useState<Boolean>(true)
  const load = async () => {
    setPricing(await getPricing(''))
    setIsLoading(false)
  }

  useEffect(() => {
    load()
  }, [isLoading])

  if (isLoading) {
    return (<>Loading... </>)
  }


  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }
  const schema = Yup.object().shape({
    _id: Yup.string().required('Select a payment method'),
    label: Yup.string().min(3, 'Minimum 3 characters').required('Label is required'),
    enabled: Yup.boolean().required('Checkbox is required')
  })

  return (
    <Formik
      initialValues={selected || {}}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          if (values) {
            await updatePricing(values as Pricing)

            close()
            refetch()
          }
        } catch (e: any) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {(props) => {
        return (
          <Form id="edit-paymode" className='form'>
            <Field
              default="Select a payment method"
              component={CustomSelect}
              label="Payment method"
              name="_id"
              options={pricing.map((p: Pricing) => {
                return { value: p._id, label: `${p.label} - ${p.country}` }
              })}
              onChange={async (e: React.ChangeEvent<HTMLSelectElement>) => {
                const selectedPricing = pricing.find(p => p._id === e.target.value);
                setSelected(selectedPricing) // Update selected state when the select input changes
                // Manually set field values based on the selected pricing
                props.setFieldValue('type', selectedPricing?.type || '')
                props.setFieldValue('label', selectedPricing?.label || '')
                props.setFieldValue('enabled', selectedPricing?.enabled || false)
              }}
            />

            {selected && (
              <>
                <div className="separator separator-dashed my-5"></div>
                <Field
                  name="type"
                  type="text"
                  component={InputText}
                  label="Type"
                  readOnly={true}
                />

                <Field
                  name="label"
                  id="label"
                  type="text"
                  component={InputText}
                  placeholder="Payment method name"
                  label="Payment method name"
                  required={true}
                />

                <Field
                  id='enabled'
                  name="enabled"
                  component={Checkbox}
                  label="Enabled"
                  defaultChecked={selected.enabled}
                />
              </>
            )}

            <Field
              component={FormActions}
              close={close}
            />

          </Form>
        )
      }}
    </Formik>
  )
}

export {PricingForm}
